import { useState } from "react";
import { PreferedCard } from "../card";
import { Skeleton } from "@mui/material";
import { collection, getCountFromServer } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function TotalUsers() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [totalUsers, setTotalUsers] = useState(null);

    async function getTotalUsers() {
        const count = await getCountFromServer(collection(db, 'users'));
        setTotalUsers(count.data().count);
    }

    if (totalUsers === null) {
        getTotalUsers();
    }
    
    return <PreferedCard title={t('homePage.users')} subtitle={t('homePage.usersDesc')} onClick={() => {navigate('/users')}}>
        {totalUsers !== null
            ? <h1 style={{margin: 0, color: 'var(--data-color)'}}>{totalUsers}</h1>
            : <Skeleton variant="rounded" width={'100%'} height={60} />}
    </PreferedCard>;
}